<template>
    <b-list-group class="accordion" role="tablist">
        <b-card v-for="(question, qIndex) in questions" no-body bg-variant="white" :key="'q-' + qIndex">
            <b-card-header class="faq-header"
                           header-tag="header"
                           role="tab"
                           header-bg-variant="white"
            >
                <b-button block
                          v-b-toggle="resolveName(question)"
                          class="faq-button btn-action"
                >
                    {{ question.title }}
                    <b-icon-chevron-down></b-icon-chevron-down>
                </b-button>
            </b-card-header>
            <b-collapse :id="resolveName(question)" :visible="question.visible" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <b-card-text v-html="question.message"></b-card-text>
                </b-card-body>
            </b-collapse>
        </b-card>
    </b-list-group>
</template>

<script>
import {BIconChevronDown} from 'bootstrap-vue';
export default {
    components: {
        BIconChevronDown
    },
    data() {
        return {
            questions: [
                {
                    id: 1,
                    title: this.$t('faq.howDoesItWorkTitle'),
                    message: this.$t('faq.howDoesItWorkMessage'),
                    visible: true,
                },
                {
                    id: 2,
                    title: this.$t('faq.whereIsTheOrderNumberTitle'),
                    message: this.$t('faq.whereIsTheOrderNumberMessage'),
                    visible: true,
                },
                {
                    id: 3,
                    title: this.$t('faq.whatAreTheRuleForReturnsTitle'),
                    message: this.$t('faq.whatAreTheRuleForReturnsMessage'),
                    visible: false,
                },
                {
                    id: 4,
                    title: this.$t('faq.whatAreTheRuleForComplaintsTitle'),
                    message: this.$t('faq.whatAreTheRuleForComplaintsMessage'),
                    visible: false,
                },
                {
                    id: 5,
                    title: this.$t('faq.whenDoWeGetOurMoneyBackTitle'),
                    message: this.$t('faq.whenDoWeGetOurMoneyBackMessage'),
                    visible: false,
                }
            ]
        }
    },
    methods: {
        resolveName(item) {
            return 'question-' + item.id;
        },
    }
}
</script>
<style scoped>
.faq-header {
    padding: 0 !important;
}
.faq-header > button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0;
    text-decoration: none;
    color: #111111;
    background: #ffffff;
}
button[aria-expanded=true] .bi-chevron-down {
    transform: rotate(180deg);
    transition: transform 0.3s ease-in-out;
}
</style>
